import { CheckCircle2, Mail, AlertCircle } from 'lucide-react';

export type WorkOSStatus = 'active' | 'invited' | 'inactive' | 'none';

export function WorkOSBadge({ status }: { status: WorkOSStatus }) {
  switch (status) {
    case 'active':
      return (
        <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-green-50 text-green-700 ring-1 ring-green-600/20">
          <CheckCircle2 size={10} />
          Active
        </span>
      );
    case 'invited':
      return (
        <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 ring-1 ring-amber-600/20">
          <Mail size={10} />
          Invited
        </span>
      );
    case 'inactive':
      return (
        <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-surface-muted text-muted ring-1 ring-neutral-300">
          <AlertCircle size={10} />
          Inactive
        </span>
      );
    default:
      return <span className="text-xs text-subtle">&mdash;</span>;
  }
}
